/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type { TypeManufacturersProductsStore } from 'stores/ManufacturersProductsStore.js';
import Loading from 'components/Loading/Loading';
import finderColumns from 'components/FinderColumns/FinderColumns';
import Activity from 'components/Activity/Activity';

import ManufacturerDetails from '../ManufacturerDetails/ManufacturerDetails';
import styles from './ManufacturerDetailsActivity.module.scss';
import { generateUrl, manufacturer } from 'api/routes';

type InjectedProps = {
  manufacturersProductsStore: TypeManufacturersProductsStore,
} & TranslatorProps;

@translate()
@inject('manufacturersProductsStore')
@finderColumns
@observer
export default class ManufacturerDetailsActivity extends ComponentWithInjectedProps<
  {},
  {},
  InjectedProps
> {
  @observable value: number = 0;

  handleTabChange = (ev: SyntheticInputEvent<*>, value: number) => {
    this.value = value;
  };

  render(): ?React.Node {
    const { manufacturersProductsStore, t } = this.props;

    const value: number = this.value;

    if (!manufacturersProductsStore.manufacturers.length) {
      return null;
    }

    if (!manufacturersProductsStore.selectedManufacturerId) {
      return (
        <div className={styles['finder-column-empty']}>
          <p>{t('general:manufacturers.messages.select')}</p>
        </div>
      );
    }

    if (manufacturersProductsStore.loadingSpecificManufacturer) {
      return <Loading />;
    }

    return (
      <div className={styles['manufacturer-detail']}>
        <Typography variant="title" color="inherit">
          {manufacturersProductsStore.selectedManufacturer.name}
        </Typography>
        <Tabs value={value} onChange={this.handleTabChange} fullWidth={true}>
          <Tab label={t('general:detail_plural')} />
          <Tab label={t('general:activity')} />
        </Tabs>
        {value === 0 && (
          <TabContainer>
            <ManufacturerDetails />
          </TabContainer>
        )}
        {value === 1 && (
          <TabContainer>
            <Activity
              url={generateUrl(manufacturer.activity, [
                manufacturersProductsStore.selectedManufacturerId,
              ])}
              allowFilter={true}
            />
          </TabContainer>
        )}
      </div>
    );
  }
}

class TabContainer extends React.Component<*> {
  render(): React.Node {
    return <div className={styles['tab-container']}>{this.props.children}</div>;
  }
}
